<template>
    <DashboardSnippet :auth="{ user }">
        <div class="p-1">
            <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3 mb-4">
                <div class="d-flex flex-wrap align-items-center gap-3">
                    <h4 class="dash-title mb-0">{{ station.name }} Overview</h4>
                </div>
            </div>

            <div class="row g-3 mb-4">
                <div class="col-6 col-md-3">
                    <Counter
                        title="Available Stocks"
                        :value="station.stocks?.length ?? 0"
                        icon="fa fa-battery-half"
                        color="text-primary"
                    />
                </div>
                <div class="col-6 col-md-3">
                    <Counter
                        title="Total Swaps"
                        :value="station.swaps_count ?? 0"
                        icon="fa fa-recycle"
                        color="text-success"
                    />
                </div>
                <div class="col-6 col-md-3">
                    <Counter
                        title="Faulty Batteries"
                        :value="station.faulty_count ?? 0"
                        icon="fa fa-triangle-exclamation"
                        color="text-danger"
                    />
                </div>
            </div>
        </div>
    </DashboardSnippet>
</template>

<script lang="ts">
import type Admin from '@/models/Admin'
import DashboardSnippet from './DashboardSnippet.vue'
import Counter from '@/widget/Counter.vue'
import { Component, Prop, Vue, toNative } from 'vue-facing-decorator'

@Component({
    components: { DashboardSnippet, Counter },
})
class Station extends Vue {
    @Prop({ type: Object, required: true })
    readonly user!: Admin

    @Prop({ type: Object, required: true })
    readonly station!: Record<string, any>
}

export default toNative(Station)
</script>
